export default __webpack_public_path__ + "static/andrew_chiarello-7f64549ac1c81ac5ae7f96f2b9ee1b2b.jpg";